import { render, staticRenderFns } from "./FontOptions.vue?vue&type=template&id=8985198c&scoped=true&"
import script from "./FontOptions.vue?vue&type=script&lang=js&"
export * from "./FontOptions.vue?vue&type=script&lang=js&"
import style0 from "./FontOptions.vue?vue&type=style&index=0&id=8985198c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8985198c",
  null
  
)

export default component.exports